<template>
  <div v-if="checkPermission()">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      userPermissions: null,
    };
  },
  created() {
    try {
      this.userPermissions = JSON.parse(
        window.$("#hidden_current_user_permissions").val()
      );
    } catch (e) {
      window.notify.error("Failed to validate user permissions!");
      throw new Error(e);
    }
  },
  methods: {
    checkPermission() {
      if (this.isValidPermission() && this.userPermissions) {
        return this.permissions.some(
          (permission) => this.userPermissions[permission]
        );
      }
      return false;
    },
    isValidPermission() {
      // Checks for invalid permissions that do not exist
      // Will throw an error and return false
      const permissionKeys = Object.keys(this.userPermissions);
      const invalidPermission = this.permissions.some((permission) => {
        if (!permissionKeys.includes(permission)) {
          const errorMessage = `Invalid "${permission}" permission requested! That permission does not exist.`;
          window.notify.error(errorMessage);
          throw new Error(errorMessage);
        }
        return false;
      });
      return !invalidPermission;
    },
  },
};
</script>

<style lang="scss" scoped></style>
